let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("R2BG5")).then(() => parcelRequire('iqlPg'));